import { LOCATION_CHANGE, replace } from 'react-router-redux';
import { put, fork, takeLatest, all, select, call } from 'redux-saga/effects';
import { get, endsWith, trimEnd } from 'lodash';

import { selectUser } from 'modules/user';
import { showNotification } from 'modules/snackbar';

function* onEditViewLoad(registrySchemaData, action) {
  const user = yield select(selectUser);

  if (
    !get(registrySchemaData, 'organizationId') ||
    get(user, 'organization.organizationId') !==
      parseInt(registrySchemaData.organizationId)
  ) {
    yield put(replace(trimEnd(action.payload.pathname, '/edit')));
    yield put(
      showNotification(
        'You do not have the required permissions to edit this schema.'
      )
    );
  }
}

function* watchDataSchemaFetch(registrySchemaData) {
  if (!registrySchemaData) {
    yield put(showNotification('The specified schema was not found.'));
  }
}

function* watchEditViewLoad(registrySchemaData, location) {
  if (endsWith(location.pathname, '/edit')) {
    yield call(onEditViewLoad, registrySchemaData, {
      payload: {
        pathname: location.pathname
      }
    });
  }

  yield takeLatest(
    action =>
      action.type === LOCATION_CHANGE &&
      endsWith(action.payload.pathname, '/edit'),
    onEditViewLoad,
    registrySchemaData
  );
}

export default function* root({ registrySchemaData, location }) {
  yield all([
    fork(watchDataSchemaFetch, registrySchemaData),
    // verify whether user is able to edit a schema
    fork(watchEditViewLoad, registrySchemaData, location)
  ]);
}



// WEBPACK FOOTER //
// ./src/client/plugins/structured-data/modules/details-sagas.js